import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  play: {
    id: 'donater.audio_player.play_button_text',
    defaultMessage: 'Play',
  },
})
